import React from 'react';
import './StudentCampaignSection.css';
// import { Link } from 'react-router-dom';

const StudentCampaignSection = () => {
  // 画面の文言（必要に応じて編集）
  const headlineTop = '10月スタート';
  const headlineSub = '第一期生募集！';
  const tagline = '限定10名！AI時代の先駆者になろう';
  const deadlineLabel = '9月25日';// 応募締切表示

return (
	<div className="student-campaign heroCohort" aria-label="募集告知セクション">

		{/* 上部バッジ */}
		<div className="heroCohort__topBadge" role="note" aria-label="期間限定">
			<span className="emoji" role="img" aria-label="fire">🔥</span>
			期間限定
		</div>

		{/* 見出し */}
		<h1 className="heroCohort__title">
			<span className="title-top">{headlineTop}</span>
			<span className="title-sub">{headlineSub}</span>
		</h1>

		{/* サブコピー */}
		<p className="heroCohort__tagline">{tagline}</p>

		{/* ピル情報（残り人数／締切／特典） */}
		<ul className="heroCohort__pills" aria-label="募集情報">
			<li className="pill">
				{/* 時計アイコン */}
				<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
					<path fill="currentColor" d="M12 1a11 11 0 1 0 11 11A11.013 11.013 0 0 0 12 1Zm1 11h5v2h-7V6h2Z"/>
				</svg>
				最終応募締切：{deadlineLabel}
			</li>
			{/* <li className="pill pill--accent"> */}
				{/* きらめき風アイコン */}
				{/* <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
					<path fill="currentColor" d="M11.99 2L15 8l6 .87l-4.36 4.25L17.82 20L12 16.9L6.18 20l1.18-6.88L3 8.87L9 8z"/>
				</svg>
				入学金20%OFF特典付き
			</li> */}
		</ul>

		{/* アクション（左：応募ボタン / 右：白い入力枠） */}
		<div className="heroCohort__actions">
			<button
				type="button"
				className="btn btn-primary"
				onClick={() => window.open('https://forms.gle/cEmeaFZNhn2M1JUY7', '_blank', 'noopener,noreferrer')}
			>
				今すぐ応募
			</button>
		</div>
	</div>
);
};

export default StudentCampaignSection;
